<template lang="html">
<div>

<!-- <el-radio-group v-model="isCollapse" style="margin-bottom: 20px;">
  <el-radio-button :label="false">expand</el-radio-button>
  <el-radio-button :label="true">collapse</el-radio-button>
</el-radio-group> -->

<el-menu :router="true" default-active="2" v-if="hotel" @open="handleOpen" @close="handleClose" :collapse="isCollapse" class="nav h100"
      :background-color="hotel.colors.primary"
      text-color="#fff"
      active-text-color="#fff">

<div class="grid logo">

  <el-menu-item v-if="isCollapse" @click="isCollapse = false">
    <i class="fas fa-bars"></i>
    <span slot="title">Apri menu</span>
  </el-menu-item>

  <el-menu-item v-if="!isCollapse" @click="isCollapse = true">
    <i class="fas fa-bars"></i>
    <span slot="title">Chiudi menu</span>
  </el-menu-item>

</div>

<div class="grid actions">

  <el-submenu index="1" v-if="hotels.length > 1">
    <template slot="title">
      <i class="fas fa-random"></i>
      <span slot="title" v-if="!isCollapse">Hotels</span>
    </template>
    <el-menu-item-group>
      <el-menu-item v-if="hotel.beachtype === 'grid'" :index="'/ombrelli/' + hotel._id" @click="changeHotel(hotel)" v-for="(hotel, index) in hotels" :key="index">{{hotel.name}}</el-menu-item>
      <el-menu-item v-if="hotel.beachtype === 'canvas'" :index="'/Canvas/' + hotel._id" @click="changeHotel(hotel)" v-for="(hotel, index) in hotels" :key="index">{{hotel.name}}</el-menu-item>
    </el-menu-item-group>
  </el-submenu>

  <el-menu-item :index="'/ombrelli/' + hotel._id" v-if="hotel.beachtype === 'grid'">
    <i class="fas fa-th"></i>
    <span slot="title">Spiaggia {{hotel.name}}</span>
  </el-menu-item>

  <el-menu-item :index="'/Canvas/' + hotel._id" v-if="hotel.beachtype === 'canvas'">
    <i class="fas fa-umbrella-beach"></i>
    <!-- <span slot="title">Spiaggia {{hotel.name}}</span> -->
  </el-menu-item>

<!--   <el-menu-item :index="'/Pool/' + hotel._id" >
    <i class="fas fa-swimming-pool"></i>
    <span slot="title">Pool {{hotel.name}}</span>
  </el-menu-item>
 -->

  <div class="spacer sm"></div>

  <el-menu-item :index="'/Pool/' + hotel._id" v-if="pool" v-on:click="editpool">
    <i class="fas fa-wrench"></i>
    <span slot="title">Edit Canvas</span>
  </el-menu-item>

  <el-menu-item :index="'/Pool/' + hotel._id" v-if="pool" v-on:click="addpool">
    <i class="fas fa-swimming-pool"></i>
    <span slot="title">Add Pool</span>
  </el-menu-item>

  <el-menu-item :index="'/Pool/' + hotel._id" v-if="pool" v-on:click="addombrid">
    <i class="fas fa-umbrella-beach"></i>
    <span slot="title">Add Ombrello</span>
  </el-menu-item>


  <el-menu-item :index="'/Canvas/' + hotel._id" v-if="canvas" v-on:click="editCanvas">
    <i class="fas fa-wrench" v-if="!edit"></i>
    <i class="fas fa-save" v-if="edit"></i>
    <span slot="title" v-if="!edit">Imposta spiaggia</span>
    <span slot="title" v-if="edit">Salva Impostazioni</span>
  </el-menu-item>

  <el-menu-item :index="'/Canvas/' + hotel._id" v-if="canvas && edit" v-on:click="addombrid">
    <i class="fas fa-umbrella-beach"></i>
    <span slot="title">Agiungi ombrello</span>
  </el-menu-item>


</div>

<div class="grid footer">

  <el-menu-item index="/addhotel">
    <i class="fas fa-plus-square"></i>
    <span slot="title">Aggiungi Hotel</span>
  </el-menu-item>

<!--   <el-menu-item @click="dialogVisible = true">
    <i class="fas fa-trash"></i>
    <span slot="title">Cancella {{hotel.name}}</span>
  </el-menu-item> -->

  <el-menu-item @click="settings">
    <i class="fas fa-cog"></i>
    <span slot="title">Impostazioni {{hotel.name}}</span>
  </el-menu-item>

  <el-menu-item index="/logout">
    <i class="fas fa-power-off"></i>
    <span slot="title">Log Out</span>
  </el-menu-item>

</div>

</el-menu>


<!-- <el-dialog
  title="Tips"
  :visible.sync="dialogVisible"
  width="30%">
  <span>Sei sicuro di voler cancellare {{hotel.name}}</span>
  <span slot="footer" class="dialog-footer">
    <el-button type="primary" @click="dialogVisible = false">Cancel</el-button>
    <el-button type="danger" @click="deleteHotel">Cancella</el-button>
  </span>
</el-dialog> -->

<settings :hotel="hotel"></settings>


    </div>
</template>

<script>
var host = process.env.ROOT_API
// import router from './../router'
import Settings from '@/components/Settings'
export default {
  props: ['title', 'hotel', 'settings', 'ombrelli', 'addpool', 'addombrid', 'addombrell', 'editpool', 'editCanvas', 'edit', 'getOmbrelli'],
  data: function () {
    return {
      ombrellostats: {
        free: [],
        occupied: []
      },
      hotels: '',
      pool: false,
      canvas: false,
      isCollapse: true
      // dialogVisible: false
    }
  },
  components: {
    Settings
  },
  methods: {
    // deleteHotel () {
    //   console.log('hotel: ', this.hotel)
    //   this.$http
    //     .post(host + '/api/deletehotel', {hotel: this.hotel},
    //     {
    //       headers: {
    //         'Authorization': 'Bearer ' + localStorage.jwt
    //       }
    //     },
    //     ).then((data) => {
    //       console.log(data)
    //       this.$notify({
    //         group: 'foo',
    //         title: this.hotel.name + ' deleted',
    //         type: 'info',
    //         duration: 500
    //       })
    //       router.push('/hotel')
    //     }, (error) => {
    //       console.log(error)
    //     })
    // },
    changeHotel (hotel) {
      // console.log('hotel: ', hotel)
      // this.$router.push('/ombrelli/' + hotel._id)
      this.getHotel()
      this.getOmbrelli()
      // window.location.reload()
    },
    handleOpen (key, keyPath) {
      // console.log(key, keyPath)
    },
    handleClose (key, keyPath) {
      // console.log(key, keyPath)
    },
    stats () {
      // console.log('ombrelli' + this.ombrelli)
    },
    getHotel () {
        // console.log('hotelid: ' + this.hotelid)
        // console.log(localStorage)
      this.$http
        // .get('http://srv5.ghosted.it:8000/authorized',
        .get(host + '/ombrelloni',
        {
          headers: {
            'Authorization': 'Bearer ' + localStorage.jwt
          }
        },
        ).then((data) => {
          this.hotels = data.body.hotels
          // console.log(data)
        }, (error) => {
          console.log(error)
        })
    }
  },
  computed: {
    hotelgrid: function () {
    // `this` points to the vm instance
      if (this.hotel.lang === 'undefined') {
        this.$i18n.locale = 'en'
      } else {
        this.$i18n.locale = this.hotel.lang
      }
      // this.ombrelli.forEach((ombrello, index) => {
      //   // console.log(ombrello.free)
      //   if (ombrello.free) {
      //     this.ombrellostats.free.push(ombrello.ombrid)
      //   } else {
      //     this.ombrellostats.occupied.push(ombrello.ombrid)
      //   }
      // })
      return this.hotel.cols * this.hotel.rows
    }
  },
  beforeMount () {
    this.getHotel()
  },
  mounted: function () {
    // this.stats()
    // console.log(this.$route.name)
    if (this.$route.name === 'Pool') {
      this.pool = true
    } else if (this.$route.name === 'Canvas') {
      this.canvas = true
    }
  }
}
</script>

<style lang="css">
    .test {
        color: pink;
        font-size: 20px;
    }
</style>



// WEBPACK FOOTER //
// Navbar.vue?25832380